var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoMilestones(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 168.223,
    height: 168.692,
    viewBox: "0 0 168.223 168.692",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4928",
    "data-name": "Group 4928",
    transform: "translate(-657.769 -1742.433)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Task-bro",
    transform: "translate(345.438 1677.066)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-65",
    transform: "translate(312.331 65.367)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8106",
    "data-name": "Path 8106",
    d: "M76.057,32.909c37.824-7.347,63.724,22.6,73.167,33.014l28.438,31.371c8.61,9.5,17.459,19.428,20.311,31.094,3.539,14.476,1.5,39.459-10.58,50.288S158.342,195.95,140.9,198.7s-35.432,1.919-53.014-.092c-10.173-1.152-20.392-2.775-29.739-6.315s-17.835-9.19-22.468-16.806c-5.57-9.159-5.033-20.069-2.66-30.142s6.434-19.9,7.555-30.119C41.558,106.364,23.09,43.2,76.057,32.909Z",
    transform: "translate(-31.314 -31.762)",
    fill: "#64b5f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8107",
    "data-name": "Path 8107",
    d: "M76.057,32.909c37.824-7.347,63.724,22.6,73.167,33.014l28.438,31.371c8.61,9.5,17.459,19.428,20.311,31.094,3.539,14.476,1.5,39.459-10.58,50.288S158.342,195.95,140.9,198.7s-35.432,1.919-53.014-.092c-10.173-1.152-20.392-2.775-29.739-6.315s-17.835-9.19-22.468-16.806c-5.57-9.159-5.033-20.069-2.66-30.142s6.434-19.9,7.555-30.119C41.558,106.364,23.09,43.2,76.057,32.909Z",
    transform: "translate(-31.314 -31.762)",
    fill: "#fff",
    opacity: 0.7
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Checklist--inject-6",
    transform: "translate(662.654 1753.557)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24487",
    "data-name": "Path 24487",
    d: "M263.258,239.605,177.31,263.8a4.5,4.5,0,0,1-4.912-2.025l-65.177-117.3a2.552,2.552,0,0,1,1.637-3.865l85.948-24.19a4.484,4.484,0,0,1,4.906,2.019l65.165,117.3a2.557,2.557,0,0,1-1.62,3.871Z",
    transform: "translate(-106.824 -114.203)",
    fill: "#263238",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24488",
    "data-name": "Path 24488",
    d: "M226.56,345.312s49.665-11.815,83.1-23.392Z",
    transform: "translate(-157.283 -200.863)",
    fill: "#884849"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24489",
    "data-name": "Path 24489",
    d: "M262.84,237.674l-83.1,23.392L115.47,145.4l83.1-23.386Z",
    transform: "translate(-110.468 -116.616)",
    fill: "#fff",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_891",
    "data-name": "Line 891",
    y1: 1.817,
    x2: 6.451,
    transform: "translate(63.485 28.074)",
    fill: "#fff",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_892",
    "data-name": "Line 892",
    y1: 11.19,
    x2: 39.754,
    transform: "translate(18.738 31.297)",
    fill: "#fff",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_893",
    "data-name": "Line 893",
    y1: 4.513,
    x2: 16.027,
    transform: "translate(56.409 32.564)",
    fill: "#fff",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_894",
    "data-name": "Line 894",
    y1: 5.682,
    x2: 20.187,
    transform: "translate(31.848 38.309)",
    fill: "#fff",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_895",
    "data-name": "Line 895",
    y1: 1.932,
    x2: 6.868,
    transform: "translate(21.231 45.044)",
    fill: "#fff",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_896",
    "data-name": "Line 896",
    y1: 8.789,
    x2: 31.226,
    transform: "translate(43.709 37.059)",
    fill: "#fff",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_897",
    "data-name": "Line 897",
    y1: 3.691,
    x2: 13.111,
    transform: "translate(23.731 47.78)",
    fill: "#fff",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24490",
    "data-name": "Path 24490",
    d: "M258.222,155.91a7.435,7.435,0,0,0-8.1-3.344,4.223,4.223,0,0,0-2.708,6.393,7.417,7.417,0,0,0,8.1,3.344A4.235,4.235,0,0,0,258.222,155.91Z",
    transform: "translate(-165.802 -129.404)",
    fill: "#fff",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_898",
    "data-name": "Line 898",
    x1: 6.451,
    y2: 1.817,
    transform: "translate(29.87 60.7)",
    fill: "#fff",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_899",
    "data-name": "Line 899",
    x1: 39.754,
    y2: 11.19,
    transform: "translate(41.314 48.104)",
    fill: "#fff",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_900",
    "data-name": "Line 900",
    x1: 16.027,
    y2: 4.513,
    transform: "translate(32.363 62.499)",
    fill: "#fff",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_901",
    "data-name": "Line 901",
    x1: 20.187,
    y2: 5.682,
    transform: "translate(52.764 55.585)",
    fill: "#fff",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_902",
    "data-name": "Line 902",
    x1: 6.868,
    y2: 1.932,
    transform: "translate(76.7 52.6)",
    fill: "#fff",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_903",
    "data-name": "Line 903",
    x1: 31.22,
    y2: 8.789,
    transform: "translate(34.863 62.714)",
    fill: "#fff",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_904",
    "data-name": "Line 904",
    x1: 13.116,
    y2: 3.691,
    transform: "translate(72.95 57.09)",
    fill: "#fff",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24491",
    "data-name": "Path 24491",
    d: "M277.462,190.538a7.417,7.417,0,0,0-8.1-3.344,4.2,4.2,0,0,0-2.708,6.364,7.412,7.412,0,0,0,8.1,3.344A4.2,4.2,0,0,0,277.462,190.538Z",
    transform: "translate(-173.911 -143.996)",
    fill: "#fff",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_905",
    "data-name": "Line 905",
    y1: 1.817,
    x2: 6.451,
    transform: "translate(85.749 68.135)",
    fill: "#fff",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_906",
    "data-name": "Line 906",
    y1: 11.19,
    x2: 39.754,
    transform: "translate(41.001 71.358)",
    fill: "#fff",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_907",
    "data-name": "Line 907",
    y1: 4.513,
    x2: 16.027,
    transform: "translate(78.673 72.63)",
    fill: "#fff",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_908",
    "data-name": "Line 908",
    y1: 5.687,
    x2: 20.187,
    transform: "translate(54.112 78.37)",
    fill: "#fff",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_909",
    "data-name": "Line 909",
    y1: 1.932,
    x2: 6.868,
    transform: "translate(43.495 85.11)",
    fill: "#fff",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_910",
    "data-name": "Line 910",
    y1: 8.783,
    x2: 31.22,
    transform: "translate(65.973 77.126)",
    fill: "#fff",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_911",
    "data-name": "Line 911",
    y1: 3.691,
    x2: 13.111,
    transform: "translate(45.994 87.847)",
    fill: "#fff",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_597",
    "data-name": "Ellipse 597",
    cx: 4.906,
    cy: 6.208,
    rx: 4.906,
    ry: 6.208,
    transform: "translate(101.691 70.386) rotate(-68.54)",
    fill: "#fff",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_912",
    "data-name": "Line 912",
    x1: 6.451,
    y2: 1.817,
    transform: "translate(52.133 100.767)",
    fill: "#fff",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_913",
    "data-name": "Line 913",
    x1: 39.754,
    y2: 11.19,
    transform: "translate(63.577 88.171)",
    fill: "#fff",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_914",
    "data-name": "Line 914",
    x1: 16.027,
    y2: 4.507,
    transform: "translate(54.627 102.566)",
    fill: "#fff",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_915",
    "data-name": "Line 915",
    x1: 20.187,
    y2: 5.682,
    transform: "translate(75.028 95.652)",
    fill: "#fff",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_916",
    "data-name": "Line 916",
    x1: 6.868,
    y2: 1.932,
    transform: "translate(98.963 92.661)",
    fill: "#fff",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_917",
    "data-name": "Line 917",
    x1: 31.22,
    y2: 8.789,
    transform: "translate(57.126 102.78)",
    fill: "#fff",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_918",
    "data-name": "Line 918",
    x1: 13.111,
    y2: 3.691,
    transform: "translate(95.214 97.156)",
    fill: "#fff",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24492",
    "data-name": "Path 24492",
    d: "M315.932,259.779a7.423,7.423,0,0,0-8.1-3.344,4.223,4.223,0,0,0-2.708,6.393,7.417,7.417,0,0,0,8.1,3.344A4.218,4.218,0,0,0,315.932,259.779Z",
    transform: "translate(-190.123 -173.176)",
    fill: "#fff",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_919",
    "data-name": "Line 919",
    y1: 1.817,
    x2: 6.451,
    transform: "translate(108.012 108.201)",
    fill: "#fff",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_920",
    "data-name": "Line 920",
    y1: 11.19,
    x2: 39.754,
    transform: "translate(63.265 111.424)",
    fill: "#fff",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_921",
    "data-name": "Line 921",
    y1: 4.507,
    x2: 16.027,
    transform: "translate(100.936 112.697)",
    fill: "#fff",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_922",
    "data-name": "Line 922",
    y1: 5.682,
    x2: 20.187,
    transform: "translate(76.376 118.436)",
    fill: "#fff",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_923",
    "data-name": "Line 923",
    y1: 1.938,
    x2: 6.868,
    transform: "translate(65.759 125.171)",
    fill: "#fff",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_924",
    "data-name": "Line 924",
    y1: 8.789,
    x2: 31.22,
    transform: "translate(88.237 117.187)",
    fill: "#fff",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_925",
    "data-name": "Line 925",
    y1: 3.691,
    x2: 13.111,
    transform: "translate(68.258 127.908)",
    fill: "#fff",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_598",
    "data-name": "Ellipse 598",
    cx: 4.906,
    cy: 6.208,
    rx: 4.906,
    ry: 6.208,
    transform: "translate(123.953 110.448) rotate(-68.54)",
    fill: "#fff",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24493",
    "data-name": "Path 24493",
    d: "M186.255,120.043l-10.924,3.072c-.827.035-1.736-.029-1.99-.451-.579-1.088.162-2.106.393-3.066a4.4,4.4,0,0,0-.48-3.257,7.62,7.62,0,0,0-8.326-3.431,4.333,4.333,0,0,0-2.777,6.555,7.18,7.18,0,0,0,3.217,2.893s2.216.989,2.661,1.788c.237.422-.382.92-1.013,1.3l-11.774,3.315a2.812,2.812,0,0,0-1.8,4.253l1.591,2.858,38.227-10.756-1.591-2.864A4.935,4.935,0,0,0,186.255,120.043ZM166.8,116.305a2.436,2.436,0,0,1,2.667,1.1,1.383,1.383,0,0,1-.891,2.094,2.43,2.43,0,0,1-2.661-1.094,1.389,1.389,0,0,1,.885-2.1Z",
    transform: "translate(-126.288 -112.688)",
    fill: "#64b5f6",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24494",
    "data-name": "Path 24494",
    d: "M251.21,153.543l4.715,3.292,4.86-10.895",
    transform: "translate(-167.672 -126.701)",
    fill: "none",
    stroke: "#64b5f6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24495",
    "data-name": "Path 24495",
    d: "M270.15,187.633l4.715,3.286,4.86-10.889",
    transform: "translate(-175.653 -141.067)",
    fill: "none",
    stroke: "#64b5f6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoMilestones);
export default __webpack_public_path__ + "static/media/noMilestones.13f80174a9e8e7249c71c02aa01312ab.svg";
export { ForwardRef as ReactComponent };